var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"nark img-banner",attrs:{"src":"img/banner-7.jpg"}}),_c('sub-navigation',{attrs:{"data":_vm.navigation[3].son}}),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }